import Header from "components/Headers/Header";
import ShowSchoolsSubAdminsModal from "components/ShowSchoolsSubAdminsModal";
import Tabs from "components/Tabe";
import TableComponent from "components/TableComponent";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import { getStates } from "store/actions/fanDataAction";
import { updateAdsPermissions } from "store/actions/schoolAction";
import { newCollegeUniversities } from "store/actions/schoolAction";
import { newSchoolsData } from "store/actions/schoolAction";
import { rejectAdminRequests } from "store/actions/schoolAction";
import { acceptAdminRequests } from "store/actions/schoolAction";
import { fetchSchoolStates } from "store/actions/schoolAction";
import { getSchoolCounty } from "store/actions/schoolAction";
import { getCollegeCity } from "store/actions/schoolAction";
import { fetchStates } from "store/actions/schoolAction";
import { rejectSchoolRequest } from "store/actions/schoolAction";
import { acceptSchoolRequest } from "store/actions/schoolAction";
import { getChangeCollectiveAdminRequests } from "store/actions/schoolAction";
import {
  getApprovedCollectives,
  getCollectiveRequests,
} from "store/actions/schoolAction";
import cross from "../../assets/img/cross.svg";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import TabsInfoModal from "components/Modal/TabsInfoModal";
const Collectives = () => {
  let dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");
  const sanitizedType = type
    ? type.replace(/^['"]|['"]$/g, "")
    : "school_requests";
  const [activeTab, setActiveTab] = useState(sanitizedType);
  const [modal, setModal] = useState(false);
  const [adsModal, setAdsModal] = useState(false);
  const [loader, setLoader] = useState({
    data: false,
    btn: false,
    adBtn: false,
    loadMore: false,
  });
  let [filter, setFilter] = useState({
    instituteLevel: "",
    state: "",
    city: "",
    school: "",
    date: "",
    adminName: "",
    adminEmail: "",
  });
  const [adsData, setAdsData] = useState({
    id: "",
    adImg: "",
    permissionForAd: false,
    oldAdsImg: "",
    type: "collective",
  });
  const infoPoints = [
    "The admin can review collective details and has the authority to accept or reject collective registration requests. Once approved, the collective is moved to the 'Active collective' section, where the admin can manage collective ads and view associated sub-admins. If a collective user submits a request to change the collective admin, the admin reviews the request details and approves or rejects the change accordingly",
  ];
  const subPoints = [];
  const infoTitle = "Collectives Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  useEffect(() => {
    dispatch(fetchStates());

    dispatch(fetchSchoolStates());
  }, []);
  useEffect(() => {
    if (filter.state != "") {
      if (filter.instituteLevel == "High School") {
        dispatch(getSchoolCounty(filter.state));
      } else {
        dispatch(getCollegeCity(filter.state));
      }
    }
  }, [filter.state]);
  useEffect(() => {
    if (filter.state != "" && filter.city != "") {
      if (filter.instituteLevel == "High School") {
        dispatch(newSchoolsData(filter.state, filter.city));
      } else {
        dispatch(newCollegeUniversities(filter.state, filter.city));
      }
    }
  }, [filter.state, filter.city]);
  const [btnLoader, setBtnLoader] = useState(false);

  const [action, setAction] = useState({
    type: "",
    id: "",
    data: {},
  });

  // Add local state to manage UI updates without refresh
  const [localCollectiveRequests, setLocalCollectiveRequests] = useState([]);
  const [localChangeAdminRequests, setLocalChangeAdminRequests] = useState([]);

  const toggle = () => {
    setModal(!modal);
  };
  const toggleAds = () => {
    setAdsModal(!adsModal);
  };
  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };
  const column = [
    "Collective Admin Name",
    "Collective Email",
    "Collective Name",
    "State",
    "City",
    "County",
    "Created At",
  ];
  const keyMaps = {
    "Collective Admin Name": "name",
    "Collective Email": "email",
    "Collective Name": "instituteName",
    State: "state",
    City: "city",
    County: "noCity",
    "Created At": "created_at",
  };
  const changeAdminColumn = [
    "Current Admin Name",
    "Current Admin Email",
    "New Admin Name(Requested)",
    "New Admin Email(Requested)",
    "Created At",
  ];
  const changeAdminKeyMaps = {
    "Current Admin Name": "currentName",
    "Current Admin Email": "currentEmail",
    "New Admin Name(Requested)": "name",
    "New Admin Email(Requested)": "email",
    "Created At": "created_at",
  };

  const {
    collectiveRequests,
    activeCollective,
    changeCollectiveAdminRequests,
    schoolStates,
    collegeStates,
    city,
    county,
    school,
    college,
    lastCollectiveRequestDocument,
    collectiveRequestHasMore,
    lastApprovedCollectiveDocument,
    hasMoreApprovedCollective,
    changeCollectiveLastDocument,
    changeCollectiveHasMore,
  } = useSelector((state) => state.school);
  let { states } = useSelector((state) => state.fans);

  // Update local state when Redux state changes
  useEffect(() => {
    if (collectiveRequests) {
      setLocalCollectiveRequests(collectiveRequests);
    }
  }, [collectiveRequests]);

  useEffect(() => {
    if (changeCollectiveAdminRequests) {
      setLocalChangeAdminRequests(changeCollectiveAdminRequests);
    }
  }, [changeCollectiveAdminRequests]);

  const getStateOptions = () => {
    const states =
      filter.instituteLevel == "High School" ? schoolStates : collegeStates;
    return states.map((item, index) => (
      <option key={index} value={item.name}>
        {item.name}
      </option>
    ));
  };

  const getCountyOptions = () => {
    const newData = filter.instituteLevel == "High School" ? county : city;
    return newData.map((item, index) => (
      <option
        key={index}
        value={filter.instituteLevel == "High School" ? item.county : item.city}
      >
        {filter.instituteLevel == "High School" ? item.county : item.city}
      </option>
    ));
  };
  const getInstituteOptions = () => {
    const instituteList =
      filter.instituteLevel == "High School" ? school : college;
    return instituteList.map((item) =>
      item.institutes.map((institute, index) => (
        <option key={index} value={institute}>
          {institute}
        </option>
      ))
    );
  };

  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getCollectiveRequests("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
    dispatch(getStates());
  }, []);

  const handleGetApprovedCollectives = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getApprovedCollectives(filter, "", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreGetApprovedCollectives = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getApprovedCollectives(filter, lastApprovedCollectiveDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };
  const handleRequestedSchools = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getCollectiveRequests("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreRequestedSchools = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getCollectiveRequests(lastCollectiveRequestDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const handleGetChangeCollectiveAdminRequests = () => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getChangeCollectiveAdminRequests("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  };
  const loadMoreGetChangeCollectiveAdminRequests = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      getChangeCollectiveAdminRequests(changeCollectiveLastDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const formattedData = (data) => {
    return data.map((item) => ({
      ...item,
      created_at: moment.unix(item?.created_at.seconds).format("MM-DD-YYYY"),
      city: item.instituteLevel == "High School" ? "" : item.county,
      noCity: item.instituteLevel == "High School" ? item.county : "",
    }));
  };
  const formattedDataForAdmin = (data) => {
    return data.map((item) => ({
      ...item,
      created_at: moment.unix(item?.created_at.seconds).format("MM-DD-YYYY"),
      currentName: item.nowAdmin?.name,
      currentEmail: item.nowAdmin?.email,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name == "instituteLevel") {
      setFilter((prev) => ({
        ...prev,
        state: "",
        city: "",
        school: "",
      }));
    } else if (name == "state") {
      setFilter((prev) => ({
        ...prev,
        city: "",
        school: "",
      }));
    } else if (name == "city") {
      setFilter((prev) => ({
        ...prev,
        school: "",
      }));
    }
  };

  const handleApplyFilter = () => {
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      getApprovedCollectives(filter, "", () => {
        setLoader((prev) => ({
          ...prev,
          btn: false,
        }));
      })
    );
  };
  const handleClearFilter = () => {
    let clearFilter = {
      instituteLevel: "",
      state: "",
      city: "",
      school: "",
      date: "",
      adminName: "",
      adminEmail: "",
    };
    dispatch(getApprovedCollectives(clearFilter, "", () => {}));
    setFilter(clearFilter);
  };
  const [subAdminData, setSubAdminData] = useState({
    modal: false,
    id: "",
  });
  const toggleSubAdminModal = () => {
    setSubAdminData((prev) => ({
      ...prev,
      modal: !prev.modal,
    }));
  };
  const renderActionsActiveSchool = (row) => (
    <>
      <Button
        color="primary"
        size="sm"
        onClick={() => {
          toggleSubAdminModal();
          setSubAdminData((prev) => ({
            ...prev,
            id: row.id,
          }));
        }}
      >
        See Sub Admins
      </Button>
      <Button
        color="primary"
        size="sm"
        onClick={() => {
          toggleAds();
          setAdsData((prev) => ({
            ...prev,
            id: row.id,
            adImg: row.adImg,
            oldAdsImg: row.adImg,
            permissionForAd: row?.permissionForAd ? row.permissionForAd : false,
          }));
        }}
      >
        Collective Ads
      </Button>
    </>
  );

  const renderActions = (row) => (
    <>
      <Button
        size="sm"
        color="primary"
        onClick={() => {
          setAction({
            type: "Accept",
            id: row.id,
            data: row,
          });
          toggle();
        }}
      >
        Accept
      </Button>
      <Button
        color="danger"
        size="sm"
        onClick={() => {
          setAction({
            type: "Reject",
            id: row.id,
          });
          toggle();
        }}
      >
        Reject
      </Button>
    </>
  );

  const tabs = [
    {
      id: "school_requests",
      title: "Collective Requests",
      content: (
        <>
          {loader.data ? (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <TableComponent
                columns={column}
                data={
                  localCollectiveRequests
                    ? formattedData(localCollectiveRequests)
                    : []
                }
                keyMap={keyMaps}
                renderActions={renderActions}
              />
              {localCollectiveRequests?.length > 4 && (
                <div className="text-center py-4">
                  <Button
                    color="primary"
                    onClick={loadMoreRequestedSchools}
                    disabled={loader.loadMore || !collectiveRequestHasMore}
                  >
                    {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                  </Button>
                </div>
              )}
            </>
          )}
        </>
      ),
      onClick: handleRequestedSchools,
    },
    {
      id: "active_schools",
      title: "Active Collective",
      content: (
        <>
          {loader.data ? (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Form className="d-flex flex-wrap">
                <Col sm="6" md="4">
                  <FormGroup>
                    <Label for="instituteLevel">Institute Level</Label>
                    <Input
                      type="select"
                      name="instituteLevel"
                      id="instituteLevel"
                      value={filter.instituteLevel}
                      onChange={handleChange}
                      // disabled={activeCollective.length == 0}
                    >
                      <option value="">Select Institute Level</option>
                      <option value="High School">High School</option>
                      <option value="College">Collage</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm="6" md="4">
                  <FormGroup>
                    <Label for="state">State</Label>
                    <Input
                      type="select"
                      name="state"
                      id="state"
                      value={filter.state}
                      onChange={handleChange}
                      disabled={filter.instituteLevel == ""}
                    >
                      <option value="">Select State</option>
                      {getStateOptions()}
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm="6" md="4">
                  <FormGroup>
                    <Label for="city">
                      {" "}
                      {filter.instituteLevel == "High School"
                        ? "County"
                        : "City"}{" "}
                    </Label>
                    <Input
                      type="select"
                      name="city"
                      id="city"
                      value={filter.city}
                      onChange={handleChange}
                      disabled={filter.state == ""}
                    >
                      <option value="">
                        Select{" "}
                        {filter.instituteLevel == "High School"
                          ? "County"
                          : "City"}{" "}
                      </option>
                      {getCountyOptions()}
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm="6" md="4">
                  <FormGroup>
                    <Label for="school">School</Label>
                    <Input
                      type="select"
                      name="school"
                      id="school"
                      value={filter.school}
                      onChange={handleChange}
                      disabled={filter.city == ""}
                    >
                      <option value="">Select School</option>
                      {getInstituteOptions()}
                    </Input>
                  </FormGroup>
                </Col>
                <Col sm="6" md="4">
                  <FormGroup>
                    <Label for="adminName">Admin Name</Label>
                    <Input
                      type="text"
                      name="adminName"
                      id="adminName"
                      className="Fan_age"
                      placeholder="Enter Admin Name"
                      value={filter.adminName}
                      onChange={handleChange}
                      // disabled={activeCollective.length == 0}
                    />
                  </FormGroup>
                </Col>
                <Col sm="6" md="4">
                  <FormGroup>
                    <Label for="adminEmail">Admin Email</Label>
                    <Input
                      type="text"
                      name="adminEmail"
                      id="adminEmail"
                      className="Fan_age"
                      placeholder="Enter Admin Email"
                      value={filter.adminEmail}
                      onChange={handleChange}
                      // disabled={activeCollective.length == 0}
                    />
                  </FormGroup>
                </Col>
                <Col sm="6" md="4">
                  <FormGroup>
                    <Label for="created_at">Created At</Label>
                    <Input
                      type="date"
                      name="date"
                      id="created_at"
                      className="Fan_age"
                      placeholder="Add Date"
                      value={filter.date}
                      onChange={handleChange}
                      // disabled={activeCollective.length == 0}
                    />
                  </FormGroup>
                </Col>
                <Col className="d-flex justify-content-center justify-content-sm-end align-items-center">
                  <Button
                    color="danger"
                    // disabled={activeCollective.length == 0}
                    onClick={handleClearFilter}
                  >
                    Clear
                  </Button>
                  <Button
                    color="primary"
                    onClick={handleApplyFilter}
                    disabled={loader.btn}
                  >
                    {loader.btn ? <Spinner size="sm" /> : "Apply"}
                  </Button>
                </Col>
              </Form>
              <TableComponent
                columns={column}
                data={activeCollective ? formattedData(activeCollective) : []}
                keyMap={keyMaps}
                renderActions={renderActionsActiveSchool}
              />
              {activeCollective?.length > 4 && (
                <div className="text-center py-4">
                  <Button
                    color="primary"
                    onClick={loadMoreGetApprovedCollectives}
                    disabled={loader.loadMore || !hasMoreApprovedCollective}
                  >
                    {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                  </Button>
                </div>
              )}
            </>
          )}
        </>
      ),
      onClick: handleGetApprovedCollectives,
    },
    {
      id: "change_school_admin",
      title: "Change Admin Requests",
      content: (
        <>
          {loader.data ? (
            <div className="text-center mt-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <TableComponent
                columns={changeAdminColumn}
                data={
                  localChangeAdminRequests
                    ? formattedDataForAdmin(localChangeAdminRequests)
                    : []
                }
                keyMap={changeAdminKeyMaps}
                renderActions={renderActions}
              />
              {localChangeAdminRequests?.length > 4 && (
                <div className="text-center py-4">
                  <Button
                    color="primary"
                    onClick={loadMoreGetChangeCollectiveAdminRequests}
                    disabled={loader.loadMore || !changeCollectiveHasMore}
                  >
                    {loader.loadMore ? <Spinner size="sm" /> : " Load more"}
                  </Button>
                </div>
              )}
            </>
          )}
        </>
      ),
      onClick: handleGetChangeCollectiveAdminRequests,
    },
  ];

  const handleAction = () => {
    setBtnLoader(true);
    if (activeTab == "school_requests") {
      if (action.type == "Reject") {
        dispatch(
          rejectSchoolRequest(action.id, () => {
            // Update local state to remove the rejected item
            setLocalCollectiveRequests((prevRequests) =>
              prevRequests.filter((item) => item.id !== action.id)
            );

            toggle();
            setBtnLoader(false);
            toast.warning("Reject school Request");
          })
        );
      } else {
        dispatch(
          acceptSchoolRequest(action.id, () => {
            // Update local state to remove the accepted item
            setLocalCollectiveRequests((prevRequests) =>
              prevRequests.filter((item) => item.id !== action.id)
            );

            toggle();
            setBtnLoader(false);
            toast.success("Approved collective Request");
          })
        );
      }
    } else {
      if (action.type == "Reject") {
        dispatch(
          rejectAdminRequests(action.id, () => {
            // Update local state to remove the rejected admin request
            setLocalChangeAdminRequests((prevRequests) =>
              prevRequests.filter((item) => item.id !== action.id)
            );

            toggle();
            setBtnLoader(false);
            toast.warning("Reject school admin Request");
          })
        );
      } else {
        dispatch(
          acceptAdminRequests(action.data, () => {
            // Update local state to remove the accepted admin request
            setLocalChangeAdminRequests((prevRequests) =>
              prevRequests.filter((item) => item.id !== action.id)
            );

            toggle();
            setBtnLoader(false);
            toast.success("Approved collective admin Request");
          })
        );
      }
    }
  };
  const handleSubmitAds = (e) => {
    e.preventDefault();
    setLoader((prev) => ({
      ...prev,
      adBtn: true,
    }));
    dispatch(
      updateAdsPermissions(adsData, (res) => {
        setLoader((prev) => ({
          ...prev,
          adBtn: false,
        }));
        if (res == "success") {
          toggleAds();
        }
      })
    );
  };

  return (
    <>
      <Header />
      <Container fluid className="mb-5">
        <Row>
          <h2
            className="mb-0 ml-auto m-2 text-primary"
            style={{ cursor: "pointer" }}
            onClick={() => setInfoModalOpen(true)}
          >
            <i className="fa fa-question-circle" aria-hidden="true"></i>
          </h2>{" "}
        </Row>

        <Card className="pb-2">
          <Tabs activeTab={activeTab} toggleTab={toggleTab} tabs={tabs} />
        </Card>
      </Container>
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={modal} centered toggle={toggle}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to {action.type} request.
            </span>
            <br />
            {action.type == "Accept" && activeTab == "change_school_admin" && (
              <Row className="mt-3">
                <Col xs="6">
                  <h2>Current Admin</h2>
                  <img
                    src={action.data?.nowAdmin?.admin_image?.url}
                    alt=""
                    width="100%"
                  />
                </Col>
                <Col xs="6">
                  <h2>Requested Admin</h2>
                  <img
                    src={action.data?.admin_image?.url}
                    alt=""
                    width="100%"
                  />
                </Col>
              </Row>
            )}
            <Button color="primary" onClick={handleAction} className="mt-3">
              {btnLoader ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={toggle} className="mt-3">
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <ShowSchoolsSubAdminsModal
        isOpen={subAdminData.modal}
        toggle={toggleSubAdminModal}
        id={subAdminData.id}
      />
      <Modal isOpen={adsModal} centered toggle={toggleAds} size="md">
        <ModalBody>
          <h2 className="text-center">Ads Data</h2>
          <Row>
            <Col md="12">
              <div className=" d-flex flex-column align-items-start mb-3">
                <Label className="auth-label mt-4">Ads Photo</Label>
                <Input
                  type="file"
                  required
                  name="player_img"
                  accept="image/png, image/gif, image/jpeg"
                  onChange={(e) =>
                    setAdsData((prev) => ({
                      ...prev,
                      adImg: e.target.files[0],
                    }))
                  }
                />
                {adsData.adImg && (
                  <div className="position-relative mt-3">
                    <img
                      src={
                        adsData.adImg.name
                          ? URL?.createObjectURL(adsData.adImg)
                          : adsData.adImg
                      }
                      alt=""
                      className=" mt-2"
                      width={80}
                      height={80}
                    />
                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      style={{
                        top: "-11%",
                        left: "80%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setAdsData((prev) => ({
                          ...prev,
                          adImg: "",
                        }));
                      }}
                    />
                  </div>
                )}
              </div>
            </Col>
            <Col md="12">
              permission For Ads :
              <Input
                type="checkbox"
                className="ml-2"
                checked={adsData.permissionForAd}
                onChange={(e) =>
                  setAdsData((prev) => ({
                    ...prev,
                    permissionForAd: e.target.checked,
                  }))
                }
              />
            </Col>
          </Row>
          <div className="text-right">
            <Button
              onClick={toggleAds}
              size="sm"
              color="danger"
              disabled={loader.adBtn}
            >
              Close
            </Button>
            <Button
              color="primary"
              size="sm"
              onClick={handleSubmitAds}
              disabled={loader.adBtn}
            >
              {loader.adBtn ? <Spinner size="sm" /> : "Submit"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Collectives;
